import { AdminShell } from '@/components/layout/AdminShell';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { env } from '@/lib/env';

export function AdminConfiguracoes() {
  // TODO(parecer-mvp): wire mutable settings (platform fee %, feature flags, maintenance mode)
  return (
    <AdminShell>
      <div className="max-w-3xl">
        <h1 className="font-serif text-display-lg">Configurações</h1>
        <p className="text-muted-foreground mt-1">Variáveis de plataforma e flags. Edição inline em construção.</p>

        <Card className="mt-8">
          <CardHeader>
            <CardTitle className="text-lg">Plataforma</CardTitle>
            <CardDescription>Valores aplicados em produção (read-only).</CardDescription>
          </CardHeader>
          <CardContent>
            <dl className="divide-y divide-border/40 text-sm">
              <Row k="Platform fee" v="15%" hint="Aplicado por cima do preço definido pelo advogado" />
              <Row k="Bedrock model" v="anthropic.claude-sonnet-4-20250514-v1:0" />
              <Row k="API URL" v={env.apiUrl} />
              <Row k="WebSocket URL" v={env.wsUrl} />
              <Row k="Cognito User Pool" v={env.cognito.userPoolId || '—'} />
              <Row k="Cognito Client ID" v={env.cognito.clientId || '—'} />
              <Row k="Daily.co domain" v={env.dailyDomain} />
              <Row k="Pagar.me ambiente" v="sandbox" hint="Trocar via env var PAGARME_ENV (sandbox | live)" />
              <Row k="Pagar.me marketplace mode" v={<Badge variant="success">Ativo</Badge>} hint="Recipients + split percentual habilitados — flag PAGARME_MARKETPLACE_ENABLED=true" />
            </dl>
          </CardContent>
        </Card>

        <Card className="mt-6">
          <CardHeader>
            <CardTitle className="text-lg">Feature flags</CardTitle>
            <CardDescription>Toggles de funcionalidades.</CardDescription>
          </CardHeader>
          <CardContent>
            <dl className="divide-y divide-border/40 text-sm">
              <Row k="OAB auto-verification" v={<Badge variant="warning">Pendente</Badge>} hint="Manual por admin enquanto integração OAB nacional não existe" />
              <Row k="Google OAuth login" v={<Badge variant="warning">Pendente</Badge>} hint="Requer Google Cloud project + OAuth client" />
              <Row k="SES production access" v={<Badge variant="warning">Sandbox</Badge>} hint="Solicitar via console SES (24-48h)" />
              <Row k="GitHub Actions OIDC deploy" v={<Badge variant="warning">Pendente</Badge>} hint="Requer IAM role com trust policy GitHub" />
              <Row k="Pagar.me KYC produção" v={<Badge variant="warning">Pendente</Badge>} hint="Banner persistente no Dash — aguardando envio de docs CNPJ" />
              <Row k="PIX no sandbox" v={<Badge variant="warning">Bloqueado</Badge>} hint="Dash mostra Ativo mas API retorna 'Sem ambiente configurado' — ticket aberto" />
            </dl>
          </CardContent>
        </Card>
      </div>
    </AdminShell>
  );
}

function Row({ k, v, hint }: { k: string; v: React.ReactNode; hint?: string }) {
  return (
    <div className="py-3 flex items-start justify-between gap-4">
      <div className="flex-1 min-w-0">
        <dt className="font-medium">{k}</dt>
        {hint && <p className="text-xs text-muted-foreground mt-0.5">{hint}</p>}
      </div>
      <dd className="text-muted-foreground font-mono text-xs text-right">{v}</dd>
    </div>
  );
}
